import { useState } from 'react';
import { BillingApi, BillingInvoicesResult } from '#shared/components/AccountAndBilling/types';

// The list op is host-supplied (account vs partner endpoint) — the (c) interface. The host normalizes
// its own response into `Invoices`, so this hook only owns the loading state and the Success check.
export default function useFetchInvoices(fetchInvoicesOp: BillingApi['fetchInvoices']) {
  const [fetching, setFetching] = useState(false);
  const [invoices, setInvoices] = useState<BillingInvoicesResult['Invoices']>([]);

  const fetchInvoices: BillingApi['fetchInvoices'] = async (params) => {
    try {
      setFetching(true);
      const res = await fetchInvoicesOp(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setInvoices(res.Invoices);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  };

  return { fetching, invoices, fetchInvoices };
}
